import { user } from '@bikemap/js/services'
import { setMapViewport } from '@bikemap/js/integrations/map/actions'
import { getClientLocation } from '@bikemap/js/utility'

/**
 * Try to set the map viewport as close as possible to the current user location.
 * @param {import("redux").Store} store
 */
export default async function setMapViewportToUserLocation(store) {
    const userLocation = await askForClientLocation() || await getLocationGuess() || null
    if (userLocation) {
        store.dispatch(setMapViewport({
            center: userLocation,
        }))
    }
}

/**
 * Get the IP based location guess for the user.
 * @returns {Promise<import('@bikemap/js/map').LngLat|null>}
 */
async function getLocationGuess() {
    const { location } = await user.getLocation()
    const [lat, lng] = location
    return [lng, lat]
}

/**
 * Ask the user for location permission if necessary and get the current location if available.
 * @returns {Promise<import('@bikemap/js/map').LngLat|null>}
 */
async function askForClientLocation() {
    if (navigator.geolocation) {
        try {
            const position = await getClientLocation()
            const { longitude, latitude } = position.coords
            return [longitude, latitude]
        } catch (error) {
            // Sad, but no problem
            console.error(error.message)
        }
    }
    return null
}
